export default __webpack_public_path__ + "static/media/edm_super_engaged.28a51e47.svg";